export const cleanStorage = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user_id");
    localStorage.removeItem("workspace_assignment_id");
    localStorage.removeItem("disable_dashboards");
};
